import { AssigneeType } from '@/security/entities/AssigneeType';
export class ContactModel {
    id;
    firstName;
    lastName;
    email;
    description;
}
export class Contact extends ContactModel {
    type = AssigneeType.Contact;
    constructor(model) {
        super();
        Object.keys(model).forEach((key) => {
            this[key] = model[key];
        });
    }
    get name() {
        if (this.firstName && this.lastName) {
            return `${this.firstName} ${this.lastName} / ${this.email}`;
        }
        return this.email;
    }
    get shortName() {
        return this.email;
    }
    getAssigneeId() {
        return `${this.email}-${this.type}`;
    }
}
